import { useRequireAuth as useBaseRequireAuth } from '@nvision/oidc';

export const useRequireAuth = () => {
  return useBaseRequireAuth();
};
